import React from "react";
import { Skeleton } from "@jem-open/jem-ui";

interface SyncRunsSummaryProps {
  totalCreated: number | undefined;
  totalUpdated: number | undefined;
  totalFailedCreated: number | undefined;
  totalFailedUpdated: number | undefined;
}

const SyncRunsSummary: React.FC<SyncRunsSummaryProps> = ({
  totalCreated,
  totalUpdated,
  totalFailedCreated,
  totalFailedUpdated,
}) => (
  <div className="mb-md">
    <h2 className="font-heading text-xl font-semibold leading-tight text-greyscale-text-title">
      Recent syncs
    </h2>
    <p className="text-sm text-greyscale-text-body mt-xxs flex items-center gap-xxs flex-wrap">
      {totalCreated != null ? (
        <>
          {totalCreated} created
          {totalFailedCreated != null && totalFailedCreated > 0 && (
            <span className="text-secondary-pink-900 font-semibold">
              ({totalFailedCreated} failed)
            </span>
          )}
        </>
      ) : (
        <Skeleton className="h-4 w-24 inline-block" />
      )}
      {" · "}
      {totalUpdated != null ? (
        <>
          {totalUpdated} updated
          {totalFailedUpdated != null && totalFailedUpdated > 0 && (
            <span className="text-secondary-pink-900 font-semibold">
              ({totalFailedUpdated} failed)
            </span>
          )}
        </>
      ) : (
        <Skeleton className="h-4 w-24 inline-block" />
      )}
    </p>
  </div>
);

export default SyncRunsSummary;
